import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getPackages = () => api.get("/packages").then((r) => r.data);
export const getQuote = (payload) => api.post("/quote", payload).then((r) => r.data);
export const sendEnquiry = (payload) => api.post("/enquiry", payload).then((r) => r.data);
export const askAssistant = (payload) => api.post("/assistant/chat", payload).then((r) => r.data);
export const designCocktails = (payload) => api.post("/cocktails/design", payload).then((r) => r.data);

export const adminLogin = (password) => api.post("/admin/login", { password }).then((r) => r.data);
export const adminEnquiries = (token) => api.get("/admin/enquiries", { headers: { "X-Admin-Token": token } }).then((r) => r.data);
export const adminDeleteEnquiry = (id, token) => api.delete(`/admin/enquiries/${id}`, { headers: { "X-Admin-Token": token } }).then((r) => r.data);
export const adminConvertEnquiry = (id, token) => api.post(`/admin/enquiries/${id}/convert`, {}, { headers: { "X-Admin-Token": token } }).then((r) => r.data);
export const adminDashboard = (token) => api.get("/admin/dashboard", { headers: { "X-Admin-Token": token } }).then((r) => r.data);
export const adminBookings = (token, params = {}) => api.get("/admin/bookings", { headers: { "X-Admin-Token": token }, params }).then((r) => r.data);
export const adminCreateBooking = (payload, token) => api.post("/admin/bookings", payload, { headers: { "X-Admin-Token": token } }).then((r) => r.data);
export const adminUpdateBooking = (id, payload, token) => api.patch(`/admin/bookings/${id}`, payload, { headers: { "X-Admin-Token": token } }).then((r) => r.data);
export const adminDeleteBooking = (id, token) => api.delete(`/admin/bookings/${id}`, { headers: { "X-Admin-Token": token } }).then((r) => r.data);
